import { Locale } from "../Locale.ts";

/**
 * UI strings for the site navigation (`SiteNav.tsx`, ADR 0061 §6) and the all-worksheets
 * index page (`AllWorksheets.tsx`) — ADR 0051 part 2.
 *
 * Both components also render text that comes from `routeSeo.json` (menu
 * item labels, group headings, page titles) - that copy is marketing content
 * pinned to a page's URL and is explicitly out of scope here (ADR 0051 §2,
 * §4). Only the static chrome around it is in this catalogue.
 */
const en = {
    "nav.homeLabel": "Math Facts Worksheet Generator",
    "nav.menuButtonLabel": "Menu",
    "nav.allWorksheetsAria": "All worksheets and charts",
    "nav.siteNavAria": "Site",
    "nav.openMenuAria": "Open the site menu",
    "nav.closeMenuAria": "Close the site menu",
    "nav.skipToContent": "Skip to main content",
    "nav.allSections": "All sections",
} as const;

export type NavStringKey = keyof typeof en;

const es = {
    "nav.homeLabel": "Generador de hojas de operaciones matemáticas",
    "nav.menuButtonLabel": "Menú",
    "nav.allWorksheetsAria": "Todas las hojas de ejercicios y tablas",
    "nav.siteNavAria": "Sitio",
    "nav.openMenuAria": "Abrir el menú del sitio",
    "nav.closeMenuAria": "Cerrar el menú del sitio",
    "nav.skipToContent": "Saltar al contenido principal",
    "nav.allSections": "Todas las secciones",
} satisfies Record<NavStringKey, string>;

const fr = {
    "nav.homeLabel": "Générateur de fiches de calcul",
    "nav.menuButtonLabel": "Menu",
    "nav.allWorksheetsAria": "Toutes les fiches d'exercices et tables",
    "nav.siteNavAria": "Site",
    "nav.openMenuAria": "Ouvrir le menu du site",
    "nav.closeMenuAria": "Fermer le menu du site",
    "nav.skipToContent": "Aller au contenu principal",
    "nav.allSections": "Toutes les rubriques",
} satisfies Record<NavStringKey, string>;

export const navStrings: Record<Locale, Record<NavStringKey, string>> = { en, es, fr };
